module.exports = __webpack_public_path__ + "static/icon_milano_sudovest_grigio-f495b584edf8cfeb073cd307a3c2a6d0.svg";